import styled from 'styled-components';
import {Menu as MuiMenu, MenuItem as MuiMenuItem} from "@mui/material";
import {tokens} from "../../../theme";

export const ContextMenuContainer = styled(MuiMenu)`
    .MuiPaper-root {
        border-radius: ${tokens.radius.sm};
        border: 1px solid ${({theme}) => theme.palette.dividers.light};
    }
`;

export const ContextMenuItem = styled(MuiMenuItem)`
    font-size: ${tokens.fontSize.sm};
    padding: 8px 16px;
    min-width: 180px;
    
    &:hover {
        background-color: rgba(0, 0, 0, 0.04);
    }
`;

export const OwnerInfo = styled.div`
    display: flex;
    align-items: center;
    padding: 4px 0;
    opacity: 0.65;
    pointer-events: none;
    
    svg {
        margin-right: 8px;
        width: 16px;
        height: 16px;
    }
`;